import AutoScroll from '../helpers/AutoScroll';
import Coords from '../helpers/Coords';

class Menu
{
  constructor( options )
  {
    this.menu = document.querySelector('.menu')
    this.demoButton = document.querySelector('.demo_fixed_button')
    this.items = document.querySelectorAll('.menu__nav__item')
    this.scrollFn = new AutoScroll
    this.coords = new Coords
  }


  addScroll() {
    if(window.scrollY > 10) {
      if(!this.menu.classList.contains('scroll')) {
        this.menu.classList.add('scroll')
        this.demoButton.classList.add('show')
      }
    } else {
      if(this.menu.classList.contains('scroll')) {
        this.menu.classList.remove('scroll')
        this.demoButton.classList.remove('show')
      }
    }
  }
  scrollEvent() {
    // this.addScroll()
    // window.addEventListener('scroll', (e) => {
    //   this.addScroll()
    // })
  }
  init() {
    if(document.querySelector('.menu')) {
      this.scrollEvent()
      this.items.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const section = el.getAttribute('data-link')
          if(document.querySelector(`#${section}`)) {
            this.scrollFn.init(
                400, 
                this.coords.init(document.querySelector(`#${section}`)).top - 100
            )
          }
        })
      })
    }
  }
}
export default Menu